{
    "id": "kdtzeo1vwuxtd",
    "title": "Cinque Terre Trip",
    "startDate": "2024-01-01",
    "groupLeader": "Lorenzo",
    "phoneNumber": "3451234567",
    "email": "lorenzoceccanti123@gmail.com",
    "places": [
        {
            "id": "2paw5adrifo15",
            "filterId": "13",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "distance": 0.2,
            "rating": 4,
            "itineraryId": "kdtzeo1vwuxtd",
            "nPlans": 0,
            "types": ["restaurant", "food", "point_of_interest", "establishment"],
            "address": "Piazza del Popolo, 7/a, 19015 Levanto SP, Italie",
            "filterName": "Restaurants",
            "entity": "P",
            "name": "La Loggia Restaurant",
            "created": "2024-05-06T07:46:30.988Z",
            "modified": "2024-05-06T07:46:31.108Z",
            "checked": false,
            "geometry": {
                "lng": 9.612756,
                "lat": 44.16796
            },
            "type": "suggestions"
        },
        {
            "id": "5mnl4unwcpw9c",
            "filterId": "6",
            "place": "Corniglia",
            "locked": false,
            "gallery": [],
            "result": "Corniglia is generally considered a safe place to visit. According to the most recent data from the Italian Ministry of Interior, the overall crime rate in Corniglia is relatively low, with only 7.6 crimes per 1,000 inhabitants reported in 2019. This includes all types of crimes, such as theft, assault, and vandalism. However, it is always important to take precautions and be aware of your surroundings when traveling to any destination.",
            "type": "info",
            "name": "Security"
        },
        {
            "id": "aezgypwthc6v7",
            "filterId": "13",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "distance": 0.3,
            "rating": 4.4,
            "itineraryId": "kdtzeo1vwuxtd",
            "nPlans": 0,
            "openingHours": [
                {
                    "day": "Tuesday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Wednesday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Thursday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Friday",
                    "periods": []
                },
                {
                    "day": "Saturday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Sunday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Monday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                }
            ],
            "types": ["restaurant", "food", "point_of_interest", "establishment"],
            "address": "Corso Italia, 10, 19015 Levanto SP, Italie",
            "filterName": "Restaurants",
            "entity": "P",
            "name": "Da Tapulin",
            "created": "2024-05-06T07:46:31.167Z",
            "modified": "2024-05-06T07:46:31.595Z",
            "checked": false,
            "description": "Da Tapulin is a small restaurant located in the center of Levanto. Despite the limited space and close proximity of tables, the restaurant offers a beautiful outdoor terrace for dining. Visitors enjoyed the high quality and well-presented seafood dishes, especially the \"Fantasia di Mare\" appetizer and the stuffed anchovies. The service was precise and attentive, with a young waiter who was knowledgeable and not intrusive. The prices were considered reasonable for the quality of food and service. Visitors recommend making a reservation in advance.",
            "geometry": {
                "lng": 9.6104117,
                "lat": 44.1688509
            },
            "type": "suggestions"
        },
        {
            "id": "du3p7qfp46yvr",
            "filterId": "13",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "distance": 0.2,
            "types": ["meal_delivery", "restaurant", "point_of_interest", "food", "establishment"],
            "name": "\"LA PICEA\" PIZZERIA & BRACERIA",
            "modified": "2024-05-06T07:46:31.843Z",
            "checked": false,
            "wheelchairAccessible": true,
            "rating": 4.5,
            "itineraryId": "kdtzeo1vwuxtd",
            "nPlans": 0,
            "openingHours": [
                {
                    "day": "Tuesday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Wednesday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Thursday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Friday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Saturday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Sunday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Monday",
                    "periods": [
                        {
                            "close": "1400",
                            "open": "1200"
                        },
                        {
                            "close": "2300",
                            "open": "1830"
                        }
                    ]
                }
            ],
            "address": "Via della Concia, 18, 19015 Levanto SP, Italie",
            "filterName": "Restaurants",
            "entity": "P",
            "created": "2024-05-06T07:46:31.655Z",
            "description": "\"LA PICEA\" PIZZERIA & BRACERIA in Levanto is a casual and inviting restaurant with both indoor and outdoor seating options. Visitors rave about the exceptional pizzas with a light and crispy crust and high-quality ingredients. The staff is also highly praised for their kindness and professionalism. Customers also enjoyed the delicious gelato made in-house. The atmosphere is relaxed and the service is impeccable. Overall, visitors recommend this restaurant for its amazing food and friendly staff.",
            "geometry": {
                "lng": 9.6116692,
                "lat": 44.1704472
            },
            "title": "Pizze creative e birre artigianali serviti in una sala da pranzo informale con arredi in legno e pietra.",
            "type": "suggestions"
        },
        {
            "id": "gqzn2e1badeku",
            "filterId": "13",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "distance": 0.3,
            "types": ["restaurant", "food", "point_of_interest", "establishment"],
            "name": "Osteria Tumelin",
            "modified": "2024-05-06T07:46:32.096Z",
            "checked": false,
            "wheelchairAccessible": true,
            "rating": 4.3,
            "itineraryId": "kdtzeo1vwuxtd",
            "nPlans": 0,
            "openingHours": [
                {
                    "day": "Tuesday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                },
                {
                    "day": "Wednesday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                },
                {
                    "day": "Thursday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                },
                {
                    "day": "Friday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                },
                {
                    "day": "Saturday",
                    "periods": []
                },
                {
                    "day": "Sunday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                },
                {
                    "day": "Monday",
                    "periods": [
                        {
                            "close": "1430",
                            "open": "1200"
                        },
                        {
                            "close": "2200",
                            "open": "1900"
                        }
                    ]
                }
            ],
            "address": "Via Domenico Grillo, 32, 19015 Levanto SP, Italie",
            "filterName": "Restaurants",
            "entity": "P",
            "created": "2024-05-06T07:46:31.903Z",
            "description": "Osteria Tumelin is a well-established restaurant located in the center of Levanto. The spacious and elegant environment offers a comfortable dining experience. The staff is attentive, courteous, and prompt in their service. The menu offers a variety of delicious dishes, including fresh fried anchovies, trofie al pesto, and seafood antipasto. Visitors recommend making a reservation as the restaurant can fill up quickly. The portions are generous and the prices are reasonable. Overall, visitors praise the quality of the food and the excellent service, making Osteria Tumelin a must-visit spot in Levanto.",
            "geometry": {
                "lng": 9.611950499999999,
                "lat": 44.1675464
            },
            "title": "Piatti abbondanti di gamberi alla griglia, pasta ai frutti di mare e bistecca in sale da pranzo con pareti in pietra a vista.",
            "type": "suggestions"
        },
        {
            "id": "i9pjyem8tko4u",
            "filterId": "8",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "result": "1. Festa di San Giacomo: This is a religious festival held on July 25th to honor the patron saint of Levanto, San Giacomo. The celebration includes a procession through the town, traditional music and dance performances, and a fireworks display.  2. Levanto Jazz Festival: This annual event takes place in August and features a lineup of local and international jazz musicians. The festival includes concerts, workshops, and jam sessions, attracting jazz enthusiasts from all over the world.  3. Festa della Madonna del Soccorso: This festival is held on the first Sunday of September to celebrate the miraculous rescue of the town from a pirate attack in the 16th century. The highlight of the event is a boat procession carrying the statue of the Madonna through the town's streets.  4. Levanto in Fiore: This flower festival takes place in April and showcases the town's beautiful gardens and floral displays. Visitors can enjoy guided tours of the gardens, workshops on gardening and flower arranging, and a market selling local produce and flowers.  5. Levanto Street Food Festival: Held in June, this festival celebrates the town's culinary traditions with a variety of street food stalls offering local specialties such as focaccia, pesto, and seafood dishes. There are also cooking demonstrations, live music, and cultural performances.  6. Levanto Film Festival: This annual event, held in October, showcases a selection of international and Italian films. The festival also includes workshops, Q&A sessions with filmmakers, and outdoor screenings in the town's main square.  7. Levanto Christmas Market: In December, the town's main square is transformed into a festive market selling traditional Christmas decorations, local products, and food and drinks. There are also live performances, Christmas carol concerts, and a visit from Santa Claus.",
            "type": "info",
            "name": "Culture"
        },
        {
            "id": "qafevdhoudsxl",
            "filterId": "5",
            "place": "La Spezia",
            "locked": false,
            "gallery": [],
            "result": "1. Pesto alla Genovese: This is a traditional dish from the Ligurian region, which includes La Spezia. It is a sauce made with basil, pine nuts, garlic, olive oil, and Parmigiano-Reggiano cheese, and is typically served with pasta.  2. Focaccia: This is a flatbread that is popular throughout Italy, but the version from La Spezia is known for being particularly light and airy. It is often topped with olive oil, herbs, and sometimes cheese.  3. Farinata: This is a savory pancake made from chickpea flour, water, and olive oil. It is a popular street food in La Spezia and is often served hot and crispy.  4. Panigacci: This is a type of flatbread made from a mixture of wheat and chickpea flour. It is typically served with a variety of toppings, such as cheese, cured meats, and vegetables.  5. Stoccafisso alla Spezzina: This is a traditional fish dish made with dried cod, tomatoes, olives, capers, and herbs. It is often served as a main course and is a specialty of the region.  6. Torta di Riso: This is a sweet dessert made with rice, milk, sugar, and lemon zest. It is often served as a special treat during holidays and celebrations.  7. Ciuppin: This is a hearty fish stew made with a variety of seafood, tomatoes, and herbs. It is a popular dish in La Spezia and is often served with crusty bread for dipping.  8. Testaroli: This is a type of pasta made from a batter of flour, water, and salt. It is typically served with a pesto sauce or a tomato-based sauce.  9. Sarde in Saor: This is a dish of marinated sardines, typically served as an appetizer. The sardines are marinated in vinegar, onions, and raisins, giving them a sweet and sour flavor.  10. Castagnaccio: This is a traditional dessert made with chestnut flour, water, olive oil, and sometimes raisins and pine nuts. It is often served during the fall and winter months.",
            "type": "info",
            "name": "Food"
        },
        {
            "id": "zd3j7wv857eug",
            "filterId": "13",
            "place": "Levanto",
            "locked": false,
            "gallery": [],
            "distance": 0,
            "rating": 4.1,
            "itineraryId": "kdtzeo1vwuxtd",
            "nPlans": 0,
            "openingHours": [
                {
                    "day": "Tuesday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1800"
                        }
                    ]
                },
                {
                    "day": "Wednesday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Thursday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Friday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Saturday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Sunday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                },
                {
                    "day": "Monday",
                    "periods": [
                        {
                            "close": "2200",
                            "open": "1830"
                        }
                    ]
                }
            ],
            "types": ["restaurant", "food", "point_of_interest", "establishment"],
            "address": "Via Giuseppe Garibaldi, 10, 19016 Levanto SP, Italie",
            "filterName": "Restaurants",
            "entity": "P",
            "name": "Da Rino",
            "created": "2024-05-06T07:46:32.155Z",
            "modified": "2024-05-06T07:46:32.341Z",
            "checked": false,
            "description": "Da Rino in Levanto is a small and intimate restaurant with a romantic atmosphere. The staff is friendly, sociable, and very helpful. The menu mainly consists of seafood dishes, with a few excellent raw options. The quality of the fish is top-notch and fresh. Visitors particularly enjoyed the spaghetti with seafood and the fish of the day. The prices are reasonable for the quality of the food. The restaurant is also environmentally conscious, providing water from a dispenser and offering recycling options. The staff is attentive and even offered a complimentary limoncello. Overall, visitors recommend Da Rino for its delicious food, friendly staff, and charming atmosphere.",
            "wheelchairAccessible": true,
            "geometry": {
                "lng": 9.6136916,
                "lat": 44.1691555
            },
            "type": "suggestions"
        }
    ],
    "description": "This is a sample itiniterary",
    "documents": [],
    "days": [
        {
            "plans": [
                {
                    "type": "accommodation",
                    "id": "4c4tozt2pl1r1",
                    "gallery": [
                        {
                            "name": "room.jpg",
                            "src": "https://media.test.tripsaround.com/images/plan/4c4tozt2pl1r1/8lpebyjh6ml13.jpg?i=ffmcqh9wkxi8zrl",
                            "id": "8lpebyjh6ml13",
                            "cooords": {
                                "x": 0,
                                "y": 0,
                                "zoom": 1
                            }
                        }
                    ],
                    "name": "Accommodation 1",
                    "description": "This is a sample accommodation",
                    "address": "Via della libertà",
                    "city": "La Spezia",
                    "nights": 1,
                    "stars": 5,
                    "rooms": [
                        {
                            "id": "qs3unvwxr3yss",
                            "gallery": [
                                {
                                    "name": "room.jpg",
                                    "src": "https://media.test.tripsaround.com/images/room/qs3unvwxr3yss/70t8fjjabv6yv.jpg?i=ffj8dxhp1ifmbib",
                                    "id": "70t8fjjabv6yv",
                                    "cooords": {
                                        "x": 0,
                                        "y": 0,
                                        "zoom": 1
                                    }
                                }
                            ],
                            "name": "Room 1",
                            "description": "This is a sample room",
                            "pax": 2
                        }
                    ]
                }
            ]
        },
        {
            "plans": [
                {
                    "type": "accommodation",
                    "id": "owyihai5j53ks",
                    "gallery": [
                        {
                            "name": "room.jpg",
                            "src": "https://media.test.tripsaround.com/images/plan/owyihai5j53ks/zs84gtkfu2x67.jpg?i=ffwo8f4fmq1osss",
                            "id": "zs84gtkfu2x67",
                            "cooords": {
                                "x": 0,
                                "y": 0,
                                "zoom": 1
                            }
                        }
                    ],
                    "name": "Accommodation 2",
                    "description": "This is a sample accommodation",
                    "address": "Via della libertà",
                    "city": "Corniglia",
                    "nights": 1,
                    "stars": 5,
                    "rooms": [
                        {
                            "id": "c0vkv7qcct1b1",
                            "gallery": [
                                {
                                    "name": "room.jpg",
                                    "src": "https://media.test.tripsaround.com/images/room/c0vkv7qcct1b1/yj9fvilh2svv2.jpg?i=ffkcgy9ravpl3sg",
                                    "id": "yj9fvilh2svv2",
                                    "cooords": {
                                        "x": 0,
                                        "y": 0,
                                        "zoom": 1
                                    }
                                }
                            ],
                            "name": "Room 2",
                            "description": "This is a sample room",
                            "pax": 2
                        }
                    ]
                },
                {
                    "type": "custom",
                    "id": "xrw0xcjoxwi36",
                    "gallery": [
                        {
                            "name": "room.jpg",
                            "src": "https://media.test.tripsaround.com/images/plan/xrw0xcjoxwi36/eopl4aovytmkb.jpg?i=ff894vixued4unn",
                            "id": "eopl4aovytmkb",
                            "cooords": {
                                "x": 0,
                                "y": 0,
                                "zoom": 1
                            }
                        }
                    ],
                    "name": "Accommodation 1 - Check Out",
                    "description": "This is a sample custom plan"
                }
            ]
        },
        {
            "plans": [
                {
                    "type": "activity",
                    "id": "6ahrf2ztr48bd",
                    "gallery": [
                        {
                            "name": "library-coffee.jpg",
                            "src": "https://media.test.tripsaround.com/images/plan/6ahrf2ztr48bd/8c05qu2k4rkr6.jpg?i=ff0tmctdw2kvzs8",
                            "id": "8c05qu2k4rkr6",
                            "cooords": {
                                "x": 0,
                                "y": 0,
                                "zoom": 1
                            }
                        }
                    ],
                    "name": "Activity 1",
                    "description": "This is a sample activity",
                    "city": "Levanto"
                },
                {
                    "type": "accommodation",
                    "id": "xvv0jkhnamedn",
                    "gallery": [
                        {
                            "name": "room.jpg",
                            "src": "https://media.test.tripsaround.com/images/plan/xvv0jkhnamedn/2c8x5imbrjdpd.jpg?i=ffz7hcmwu7a9i6f",
                            "id": "2c8x5imbrjdpd",
                            "cooords": {
                                "x": 0,
                                "y": 0,
                                "zoom": 1
                            }
                        }
                    ],
                    "name": "Accommodation 3",
                    "description": "This is a sample accommodation",
                    "address": "Via della libertà",
                    "city": "Levanto",
                    "nights": 1,
                    "stars": 5,
                    "rooms": [
                        {
                            "id": "37uazpn7x875n",
                            "gallery": [
                                {
                                    "name": "room.jpg",
                                    "src": "https://media.test.tripsaround.com/images/room/37uazpn7x875n/63fioz02vs0k4.jpg?i=fftzsmurenvs6ni",
                                    "id": "63fioz02vs0k4",
                                    "cooords": {
                                        "x": 0,
                                        "y": 0,
                                        "zoom": 1
                                    }
                                }
                            ],
                            "name": "Room 3",
                            "description": "This is a sample room",
                            "pax": 2
                        }
                    ]
                }
            ]
        }
    ],
    "isPlaceCreating": false,
    "placeFilters": [
        {
            "name": "La Spezia",
            "regenerate": true,
            "filters": [
                {
                    "name": "Food",
                    "type": "info",
                    "id": "5"
                }
            ]
        },
        {
            "name": "Corniglia",
            "regenerate": true,
            "filters": [
                {
                    "name": "Security",
                    "type": "info",
                    "id": "6"
                }
            ]
        },
        {
            "name": "Levanto",
            "regenerate": true,
            "filters": [
                {
                    "name": "Culture",
                    "type": "info",
                    "id": "8"
                },
                {
                    "name": "Restaurants",
                    "type": "suggestion",
                    "id": "13"
                }
            ]
        }
    ]
}
